module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table_content"
  }, [_c('pagination-buttons'), _vm._v(" "), _c('table', {
    staticClass: "table_bordered"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.individual.answered_in')) + ":")]), _vm._v(" "), _vm._l((_vm.list.steps), function(step) {
    return _c('th', [_vm._v(_vm._s(step.sanitized_title))])
  })], 2), _vm._v(" "), _vm._l((_vm.list.submissions), function(submission) {
    return _c('tr', [_c('td', [_c('locale-date', {
      attrs: {
        "date": submission.created_at
      }
    })], 1), _vm._v(" "), _vm._l((_vm.list.steps), function(step) {
      return _c('td', [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.parseResponses(_vm.groupedAnswers(submission.answers, step.id)))
        }
      })])
    })], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "search-list-container"
  }, [_c('div', {
    staticClass: "klickart-loader-container",
    class: {
      'is-visible': _vm.isLoading
    },
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "klickart-loader"
  })])])], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7e0290c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/individual/List.vue
 ** module id = 877
 ** module chunks = 1
 **/